import { ShoppingCartIcon } from "@heroicons/react/24/outline";

import { IBasketItem } from "../../models/Basket";
import { ITillQuoteLine } from "../../models/till/ITillQuote";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import TillBasketLine from "./TillBasketLine";

interface TillBasketPaneProps {
  items: IBasketItem[];
  quoteLines?: ITillQuoteLine[];
  onClear: () => void;
  isClearing?: boolean;
  disabled?: boolean;
}

export default function TillBasketPane({ items, quoteLines, onClear, isClearing, disabled }: TillBasketPaneProps) {
  const lineFor = (partId: string) => quoteLines?.find((l) => l.kind === "Part" && l.partId?.toLowerCase() === partId.toLowerCase());

  return (
    <section className="flex h-full flex-col min-h-0 border-x border-gray-200 bg-white">
      <header className="flex items-center justify-between px-4 h-14 border-b border-gray-200">
        <h2 className="flex items-center gap-2 text-base font-semibold text-gray-900">
          <ShoppingCartIcon className="h-5 w-5 text-gray-500" />
          Basket
          <span className="ml-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700">{items.length}</span>
        </h2>
        <ButtonInput label="Clear" size="sm" classes="!bg-red-600 hover:!bg-red-700" onClick={onClear} disabled={disabled || items.length === 0} isLoading={isClearing} />
      </header>

      {items.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center text-gray-400 px-6 text-center">
          <ShoppingCartIcon className="h-12 w-12 mb-2" />
          <p>Nothing in the basket yet.</p>
          <p className="text-sm">Scan a label or tap a part in the search results.</p>
        </div>
      ) : (
        <ul className="flex-1 min-h-0 overflow-y-auto divide-y divide-gray-100">
          {items.map((item) => (
            <TillBasketLine key={item.id} item={item} quoteLine={lineFor(item.partId)} disabled={disabled} />
          ))}
        </ul>
      )}
    </section>
  );
}
